<div class="flex items-center justify-center gap-3">
  @if (preRelease && router.url.includes('emails')) {
    <i
      class="fa-regular fa-circle-question mt-[3px] cursor-pointer self-start text-[18px] text-primary"
      (click)="startTour.emit()"
      matTooltip="{{ 'startTour' | translate }}"></i>
  }
  <div class="logo tooltip relative inline-block w-[42px]">
    <img class="w-[200px]" src="../../../assets/logo.svg" alt="Logo" />
    <span class="tooltiptext">
      {{ 'pathToDigitalTransformation' | translate }}
      <div class="block">
        <a
          style="color: #a1ccfe; border-bottom: 1px solid #a1ccfe"
          target="_blank"
          href="https://www.credemtel.it"
          >www.credemtel.it</a
        >
      </div>
    </span>
  </div>

  <div
    [class]="
      'relative flex items-center rounded-md border border-gray-300 bg-white p-0.5 text-gray-600' +
      widthClass
    "
    [ngClass]="{
      'search-main': !hasInputError,
      'search-main-error': hasInputError,
    }">
    <div class="h-full flex-none pl-1 xs:pl-0">
      <button
        [disabled]="!isAnyFolder()"
        mat-icon-button
        type="submit"
        class="flex h-full flex-wrap content-center px-2"
        (click)="onSearchBtnClicked()">
        <mat-icon>search</mat-icon>
      </button>
    </div>
    <div class="flex h-full w-full items-center">
      <input
        #topInput
        style="background: white"
        class="h-8 w-full pr-2 text-sm focus:outline-none focus:ring-0"
        type="search"
        [disabled]="!isAnyFolder()"
        name="search"
        placeholder="{{ 'search' | translate }}"
        [value]="search"
        (change)="onValueChanged($event)"
        (keyup.enter)="onSearchBtnClicked()" />
      <button
        matTooltip="{{ 'resetAllFilters' | translate }}"
        [disabled]="!isAnyFolder()"
        mat-icon-button
        (click)="onXClicked()">
        <mat-icon
          [class.cursor-pointer]="isAnyFolder()"
          class="mr-[3px] scale-[0.65]"
          >close</mat-icon
        >
      </button>
    </div>
    <div class="h-full flex-none border-l border-gray-300">
      <button
        mat-icon-button
        [disabled]="!isAnyFolder()"
        type="submit"
        class="flex h-full flex-wrap content-center px-2"
        (click)="openAdvancedSearch()">
        <mat-icon
          [color]="
            (!isDefaultSearchParams && isAnyFolder()) || hasFilters || !!search
              ? 'primary'
              : ''
          ">
          tune
        </mat-icon>
      </button>
    </div>
    @if (hasInputError) {
      <div
        class="absolute bottom-[-50%] z-10 text-[10px] font-normal text-[#f44336]">
        {{ 'searchRequires' | translate }}
      </div>
    }
  </div>

  <div class="flex items-center">
    <mat-slide-toggle
      [disabled]="!isAnyFolder()"
      [checked]="!userWorkspaceService.hideNotifications"
      (change)="onHideNotificationsChanged($event)"
      color="primary"
      matTooltip="{{
        'showNotificationSearchInput' | translate
      }}"></mat-slide-toggle>
    <div class="{{ preRelease ? '' : 'hidden' }}">
      <button
        mat-icon-button
        (mouseenter)="!isOpen && (isOpen = true)"
        (click)="isOpen = !isOpen"
        type="button"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin">
        <mat-icon
          [matBadge]="!!notifications.length ? notifications.length : ''"
          matBadgeSize="small">
          notifications
        </mat-icon>
      </button>
    </div>
  </div>
</div>

<ng-template #advancedSearch>
  <app-email-search-advanced-dialog
    (closeEventEmitter)="closeAdvancedSearch()"
    (searchFilters)="
      onSearchFilters($event)
    "></app-email-search-advanced-dialog>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  (detach)="closePanel()"
  (overlayOutsideClick)="!isOpenDialogMessage && closePanel()">
  <app-notification-panel
    [notifications]="notifications"
    (markAsRead)="onMarkAsRead($event)"
    (markAllAsRead)="onMarkAllAsRead()"
    (closeNotifications)="closePanel()"
    (openDialogMessage)="openDialogMessage($event)"></app-notification-panel>
</ng-template>
